import { ReactNode } from 'react';
import { PortalHeader } from './PortalHeader';

interface PortalLayoutProps {
  children: ReactNode;
}

export function PortalLayout({ children }: PortalLayoutProps) {
  return (
    <div className="flex flex-col h-screen bg-gray-50 dark:bg-gray-900">
      <PortalHeader />
      <main className="flex-1 overflow-auto">
        {children}
      </main>
    </div>
  );
}
